import React, { useCallback, useEffect, useRef, useState } from "react";
import SelectForm from "../../../components/ComponentesFormularios/SelectForm";
import InputForm from "../../../components/ComponentesFormularios/InputForm";
import { Colors } from "../../../assets/colors/Colors";
import Tooltip from "@mui/material/Tooltip";
import RadioButtonForm from "../../../components/ComponentesFormularios/RadioButtonForm";
import { CalendarForm, CalendarFormRange } from "../../../components/ComponentesFormularios/CalendarForm";
import { modalCRUDService } from "../../../services/modalCRUDService";
import { GlobalConstants } from "../../../data/GlobalConstants";
import { useDispatch, useSelector } from "react-redux";
import {
    convertToString,
    dateToStringFormat, getDateTime,
    getFechaToCalendarRange,
    validarEspaciosEnBlanco
} from "../../../util/functions";
import { FormProvider, useForm, useFormContext, useWatch } from "react-hook-form";
import { isEmpty, isObject } from "../../../util/is";
import SelectFormVirtualize from "../../../components/ComponentesFormularios/SelectFormVirtualize";
import {
    classResponsiveForm,
    classResponsiveFormDoubleWidth, classResponsiveFormWidthHeader, ERRORFIELDREQUIRED,
    optionsEstados
} from "../../../data/ConstantForm";
import NestedSelectVirtualizeForm from "../../../components/ComponentesFormularios/NestedSelectVirtualizeForm";
import { topesService } from "src/services/apiTopes";

const AgentesTipologias = ({ isEditing,stateSelects,refAgentes,refTipologias }) => {

    const { handleSubmit, setValue, control, formState: { errors } } = useFormContext();

    const agenteComercial = useWatch({
        name: "agenteComercial",
        control
    })

    const tipologias = useWatch({
        name: "tipologias",
        control
    })

    useEffect(() => {

        if (agenteComercial != undefined) {
            let objAgentes = []
            agenteComercial.map( el => {
                objAgentes.push(el.text)
            })
            refAgentes.current.innerText = objAgentes.join(" - ")

        }
        if (tipologias != undefined) {
            let objtipologias = []
            tipologias.map( el => {
                objtipologias.push(el.text)
            })
            refTipologias.current.innerText = objtipologias.join(' - ')
        }

    }, [agenteComercial, tipologias])


    return (
        <>
            <SelectFormVirtualize inputProps={{ control }} disabled={!isEditing} identificador="oficinasVendedor" label="Oficina de Ventas"
                    options={stateSelects?.arrTipoEmpleados} required={false} className={`${classResponsiveFormWidthHeader}`}
                    customError={errors.oficinasVendedor ? ERRORFIELDREQUIRED : null} />

            <SelectFormVirtualize inputProps={{ control }} disabled={!isEditing} isMulti={true} identificador="agenteComercial" label="Agente Comercial"
                options={stateSelects?.arrAgentesComerciales} required={true} className={`${classResponsiveFormWidthHeader}`} readOnly={false}
                customError={errors.agenteComercial ? ERRORFIELDREQUIRED : null} />

            <SelectFormVirtualize inputProps={{ control }} isMulti={true} disabled={!isEditing} identificador="tipologias" label="Tipologías"
                options={stateSelects?.arrTipologias} required={true} className={`${classResponsiveFormWidthHeader}`}
                customError={errors.tipologias ? ERRORFIELDREQUIRED : null} />

            <CalendarFormRange inputProps={{ control }} disabled={!isEditing} identificador="dtVigencia" required={true} label="Fecha Inicio - Fecha Fin"
                className={`${classResponsiveFormWidthHeader}`} readOnly={true} required={false}
                customError={errors.dtVigencia ? ERRORFIELDREQUIRED : null} />

        </>
    )
}

const ProveedoresProductos = ({ isEditing,stateSelects,refProducto }) => {

    const { handleSubmit, setValue, control, formState: { errors } } = useFormContext();

    const producto = useWatch({
        name: "producto",
        control
    })

    useEffect(() => {

        if (producto != undefined) {

            refProducto.current.innerText = producto.text
        }
    }, [producto])


    return (
        <>
            <SelectFormVirtualize inputProps={{ control }} disabled={!isEditing} identificador="proveedores" label="Proveedores"
                    options={stateSelects?.arrProveedores} required={false} className={`${classResponsiveFormWidthHeader}`}
                    customError={errors.proveedores ? ERRORFIELDREQUIRED : null} />

            <NestedSelectVirtualizeForm disabled={!isEditing} keyIdentificador="producto" label="Productos" required={true}
                className={classResponsiveFormWidthHeader} options={stateSelects?.arrProductos}
                customError={errors.producto ? ERRORFIELDREQUIRED : null}
                keyFatherValue="proveedores" />

            <InputForm inputProps={{ control }} disabled={!isEditing} identificador="cantTope" label="Cantidad Tope"
                placeholder="Ej: 5" required={true} type="number" className={`${classResponsiveFormWidthHeader}`}
                customError={errors.cantTope ? ERRORFIELDREQUIRED : null} rules={{  min: 1 }} />

            <RadioButtonForm inputProps={{ control }} disabled={!isEditing} identificador="estado" options={optionsEstados} required={true}
                defaultValue="1" label="Estado" className={`${classResponsiveFormWidthHeader}`}
                customError={errors.estado ? ERRORFIELDREQUIRED : null} />

        </>
    )
}

const DatosBasicos = React.memo(({ isEditing, isAddMode, properties, stateSelects }) => {

    const {setValue, control, formState: { errors } } = useFormContext();
    const selectedAgentes = useRef(null);
    const selectedTipologias = useRef(null);
    const selectedProducto = useRef(null);
    const unavailable = true;


    return (
        <div className="container mx-0 px-0 w-100 mw-100">

            <hr className="m-0 p-0 border-2 mb-3"/>
            <div className="row mx-0 px-0 mt-3 mb-2">

                <AgentesTipologias isEditing={isEditing} stateSelects={stateSelects} refAgentes={selectedAgentes} refTipologias={selectedTipologias} />
            </div>

            <div className="row mx-0 px-0 mt-3 mb-2">

                <ProveedoresProductos isEditing={isEditing} stateSelects={stateSelects} refProducto={selectedProducto} />
            </div>

            <div className="row mx-0 px-0 mt-3 mb-2">
                <div style={{width: '49%'}} className="ml-2">
                    <strong>Producto Seleccionado</strong>
                    <div ref={selectedProducto} className={`border rounded p-2`} style={{height: '3em', overflowY: 'auto'}}></div>
                </div>
            </div>

            <div className="row mx-0 px-0 mt-3 mb-2">

                <div style={{width: '100%'}} className="ml-2">
                    <strong>Agentes Seleccionados</strong>
                    <div ref={selectedAgentes} className={`border rounded p-2`} style={{height: '8em', overflowY: 'auto'}}></div>
                </div>

            </div>

            <div className="row mx-0 px-0 mt-3 mb-4">

                <div style={{width: '100%'}} className="ml-2">
                    <strong>Tipologias Seleccionadas</strong>
                    <div ref={selectedTipologias} className={`border rounded p-2`} style={{height: '8em', overflowY: 'auto'}}></div>
                </div>
            </div>

        </div>
    )
})

const FormTopesCRUD = ({ isEditing, properties, isAddMode }) => {

    const { data, params, tableRef } = properties;
    const dispatch = useDispatch();
    const authState = useSelector(state => state.auth)
    const { idUsuario } = authState;
    const generalServicesState = useSelector(state => state.generalServices)
    const methods = useForm({
        defaultValues: {
            ...data,
            dtVigencia: getFechaToCalendarRange(data?.dtVigenciaIni ? data?.dtVigenciaIni : dateToStringFormat(new Date()), data?.dtVigenciaFin ? data?.dtVigenciaFin : dateToStringFormat(new Date()))
        }
    });
    const { register, handleSubmit, formState: { errors }, control } = methods;


    const onSuccessSubmit = data => {

        data.dtVigenciaIni = dateToStringFormat(data.dtVigencia[0]);
        data.dtVigenciaFin = dateToStringFormat(data.dtVigencia[1]);
        data.ac = isAddMode && isEditing ? 'C' : isEditing ? 'A' : 'LOCK';
        data.idUsrAuditoria = idUsuario;

        let agentes = [],
            tipologias = []

        if (data.tipologias.length < generalServicesState.arrTipologias.length) {
            data.tipologias.map( tipo => {
                tipologias.push({idTipologia: tipo.id})
            })
        }
        if (data.agenteComercial.length < generalServicesState.arrAgentesComerciales.length) {
            data.agenteComercial.map( agente => {
                agentes.push({
                    nbAgenteComercial: agente.id,
                    arrBusqueda: tipologias
                })
            })
        }
        else {
            agentes = [{
                nbAgenteComercial: '*',
                arrBusqueda: tipologias
            }]
        }

        data.jsItems = {
            txClaveBusqueda: 'TIPOLOGIAS',
            arrAgenteComerciales: agentes
        }

        topesService.crudTopes(data).then(
            response => {

                const { status, msg, data: datos } = response;

                let agentes = [],
                    tipologias = []

                data?.agenteComercial?.map( el => agentes.push(el.id))
                data?.tipologias?.map( el => tipologias.push(el.id))
                if (status) {
                    if (datos?.idmsg === 200) {
                        if (isAddMode) {
                            dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertSuccess, message: datos?.txmsg } });

                            tableRef.current.api.applyTransaction({
                                add: [{
                                    id: datos?.idreg,
                                    estado: data.estado,
                                    producto: data.producto.id,
                                    nombre: data.producto.text,
                                    cantTope: data.cantTope,
                                    lenghtTipologias: tipologias.join(' - '),
                                    lenghtAgentes: agentes.join(' - '),
                                    fechaIni: data.dtVigenciaIni,
                                    fechaFin: data.dtVigenciaFin,
                                    usrAuditor: idUsuario,
                                    fechaAuditoria: ''
                                }]
                            })
                        }
                        else {

                            dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertSuccess, message: datos?.txmsg } });

                            const rowNode = params.api.getRowNode(params.node.id);
                            const nmProducto = rowNode.data.nombre

                            rowNode.setDataValue("estado", data?.estado);
                            rowNode.setDataValue("producto", isObject(data.producto) ? data.producto.id : data.producto);
                            rowNode.setDataValue("nombre", isObject(data.producto) ? data.producto.text : nmProducto);
                            rowNode.setDataValue("cantTope", data?.cantTope);
                            rowNode.setDataValue("lenghtTipologias", tipologias.join(' - '));
                            rowNode.setDataValue("lenghtAgentes", agentes.join(' - '));
                            rowNode.setDataValue("fechaIni", data?.dtVigenciaIni);
                            rowNode.setDataValue("fechaFin", data?.dtVigenciaFin);
                            rowNode.setDataValue("usrAuditor", idUsuario);
                        }

                        modalCRUDService.clear();
                    }
                    else {
                        dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertError, message: datos?.txmsg } });
                    }

                } else {
                    dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertError, message: msg } });
                }

            },
            error => {
                dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertError, message: error.toString() } });
            }
        );
    }

    const onErrorSubmit = errors => {
        console.log(errors)
    }

    return (
        <FormProvider {...methods} >
                <header className="px-4 d-flex align-items-center mw-100 mt-2 justify-content-between">

                    <div className="row w-50">

                        <InputForm inputProps={{ control }} disabled={true} identificador="idTope" label="Id Tope"
                            placeholder="Ej: 5" required={true} type="number" className={`${classResponsiveFormWidthHeader}`} style={{width: '12em', marginLeft: 0}}
                            customError={errors.idTope ? ERRORFIELDREQUIRED : null} />
                    </div>

                    <div className="d-flex justify-content-between align-items-center">

                        {isEditing &&
                            <Tooltip title="Guardar" aria-label="guardar">
                                <a onClick={handleSubmit(onSuccessSubmit, onErrorSubmit)}
                                    className="icon-container-actions d-flex">
                                    <div style={{ backgroundColor: Colors.COLOR_GREEN_DARK }} />
                                    <i style={{ color: Colors.COLOR_GREEN_DARK }} className="fas fa-check fa-2x" />
                                </a>
                            </Tooltip>
                        }
                        <Tooltip title="Cancelar" aria-label="cancelar">
                            <a onClick={() => { modalCRUDService.clear() }} className="icon-container-actions d-flex">
                                <div style={{ backgroundColor: Colors.RED_SWITCH_INACTIVE }} />
                                <i style={{ color: Colors.RED_SWITCH_INACTIVE }} className="fas fa-times fa-2x" />
                            </a>
                        </Tooltip>
                    </div>

                </header>
                <DatosBasicos isEditing={isEditing} properties={properties} stateSelects={generalServicesState} isAddMode={isAddMode} />
        </FormProvider>
    )

}

export default FormTopesCRUD;
